import { BindingEngine, autoinject, bindable, bindingMode, customElement, observable } from 'aurelia-framework';
import { Router, activationStrategy } from 'aurelia-router';

import { BaseCustomElement } from 'Common/BaseCustomElement';
import { DataService, GetPageModeEnum } from 'DataAccessLayer/Services/DataService';
import { GuidHelper } from 'Code/Helpers/GuidHelper';
import { Layout } from 'Common/Layout/Layout';
import { LayoutHelper } from 'Common/Layout/LayoutHelper';
import { ObjectHelper } from 'Code/Helpers/ObjectHelper';
import { StringHelper } from 'Code/Helpers/StringHelper';
import { SystemService } from 'DataAccessLayer/Services/SystemService';
import { Config } from 'Config';
@autoinject
export class TextBoxFilterBaseCustomElement extends BaseCustomElement {
    @bindable({ defaultBindingMode: bindingMode.toView }) label: string = null;
    @bindable({ defaultBindingMode: bindingMode.twoWay }) value: string = null;
    @bindable({ defaultBindingMode: bindingMode.twoWay }) valueId: number = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) editable: boolean = true;
    @bindable({ defaultBindingMode: bindingMode.toView }) entityName: string = StringHelper.Empty();
    @bindable({ defaultBindingMode: bindingMode.toView }) columnName: string = StringHelper.Empty();
    @bindable({ defaultBindingMode: bindingMode.toView }) onChange: any = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) onEnter: any = null;
    @bindable({ defaultBindingMode: bindingMode.toView }) forceChange: boolean = false;
    @bindable({ defaultBindingMode: bindingMode.twoWay }) reset: boolean = false;
    @bindable({ defaultBindingMode: bindingMode.toView }) tabIndexId: number = -1;
    @bindable placeholder: string = '';

    protected id: string = StringHelper.Empty();
    protected element: any = null;
    protected customElement: any = null;
    protected schema: Object = null;
    protected systemService: SystemService = null;
    protected dataService: DataService = null;
    protected router: Router = null;
    protected autocompleteArray: Array<Object> = null;
    protected changeEventLock: boolean = false;
    protected layout: Layout = null;
    protected expanded: boolean = false;
    protected index: number = -1;
    protected suggestionsUL: any = null;
    protected userInput: String = '';
    protected updatingInput: boolean = false;
    protected isAddedEventListenerOnBodyClick: boolean = false;
    protected myHideAutocompleteCallback: any = null;
    protected isDownlineEntity: boolean = false;
    protected autocompleteEnabled: boolean = true;

    collapse() {
        this.expanded = false;
        this.index = -1;
    }

    constructor(element: Element, dataService: DataService, router: Router, systemService: SystemService) {
        super();

        this.element = element;
        this.dataService = dataService;
        this.systemService = systemService;
        this.router = router;
        this.id = GuidHelper.NewGuid();

        this.myHideAutocompleteCallback = this.HideAutocomplete.bind(this);
    }

    async bind() {
        this.isDownlineEntity = (Config.InstanceName() == 'starlife' || Config.InstanceName() == 'starlifetestovaci' || Config.InstanceName() == 'FirmaTest1') && this.entityName.startsWith("Downline");
        if (this.isDownlineEntity && this.columnName == 'FilterDescendants') {
            this.autocompleteEnabled = false;
        }
        this.schema = await SystemService.Instance.GetSchemaByEntity(this.entityName);
    }

    attached() {
        this.customElement = ($(this.element) as any);
    }

    detached() {
        // document.getElementById(`${this.id}-${this.entityName + '-' + this.columnName}-Caption`).removeEventListener("keydown");
        document.body.removeEventListener('click', this.myHideAutocompleteCallback);
    }

    keydown(key) {
        if (!this.expanded) {
            return true;
        }

        // down
        if (key === 40) {
            if (this.index < this.autocompleteArray.length - 1) {
                this.index++;
            } else {
                this.index = -1;
            }
            this.scroll();
            return;
        }

        // up
        if (key === 38) {
            if (this.index === -1) {
                this.index = this.autocompleteArray.length - 1;
            } else if (this.index > 0) {
                this.index--;
            } else {
                this.index = -1;
            }
            this.scroll();
            return;
        }

        // escape
        if (key === 27) {
            return;
        }

        // enter
        if (key === 13) {
            if (this.index >= 0) {
                this.select(this.autocompleteArray[this.index]);
                this.collapse();
            }
            else if (StringHelper.StringIs(this.value)) {
                console.log(88881, '13', this.value, this.onEnter);
                if (ObjectHelper.ObjectIs(this.onEnter)) {
                    this.onEnter();
                }
            }
            return;
        }

        return true;
    }

    scroll() {
        const ul = this.suggestionsUL;
        const li = ul.children.item(this.index === -1 ? 0 : this.index);
        if (li.offsetTop + li.offsetHeight > ul.offsetHeight) {
            ul.scrollTop += li.offsetHeight;
        } else if (li.offsetTop < ul.scrollTop) {
            ul.scrollTop = li.offsetTop;
        }
    }

    async select(selectedItem) {
        await this.SelectAutocompleteValue(selectedItem);
    }

    focus() {
        this.element.firstElementChild.focus();
    }

    blur() {
        //this.compareSetValue(false);
    }

    async valueChanged(newValue: string, oldValue: string) {
        if (this.index != -1) {
            return;
        } else if (this.index == -1 && newValue === oldValue) {
            return;
        }
        // check if new value isn't null or empty
        if (ObjectHelper.IsNullOrUndefined(newValue) || StringHelper.IsNullOrEmpty(newValue)) {
            //this.caption = null;
            //await this.UpdateEntityDescritption(null);
        }
        //
        if (this.autocompleteEnabled && !this.changeEventLock && StringHelper.StringIs(newValue) && newValue.length > 2) {
            if (this.entityName == 'Role') {
                let response = await this.systemService.FilterEntityList(this.entityName, newValue);
                this.autocompleteArray = (JSON.parse(JSON.stringify(response)));
                this.autocompleteArray = this.autocompleteArray.splice(0, 5);
            }
            else {
                let columns: Array<any> = [{ "ColumnName": this.columnName }];
                let filter: any = {};
                filter[this.columnName] = newValue;
                let response = await this.dataService.GetFilteredSorted(this.isDownlineEntity ? 'DownlineNames' : this.entityName,
                    0, 10, [{ "ColumnName": this.columnName, "Direction": "ASC" }], filter, {}, '', null, null, 1, columns, null, false, GetPageModeEnum.Normal);
                if (this.ObjectIs(response) && response.hasOwnProperty('status') && response['status'].toLowerCase() == 'ok' && ObjectHelper.ObjectIs(response['data']) && super.ArrayIs(response['data'].data)) {
                    let data1: Array<any> = JSON.parse(JSON.stringify(response['data'].data));
                    for (let i1 = 0; i1 < data1.length; i1++) {
                        data1[i1]['Caption'] = data1[i1][this.columnName];
                    }
                    this.autocompleteArray = data1;
                }
            }
            this.expanded = ObjectHelper.IsNotNullAndUndefined(this.autocompleteArray)
                && (
                    (this.autocompleteArray.length > 1)
                    ||
                    (this.autocompleteArray.length == 1 && this.autocompleteArray[0]['Caption'] != newValue)
                );
            //      
            this.customElement.find('[role="autocomplete"]').show();

            if (!this.isAddedEventListenerOnBodyClick) {
                document.body.addEventListener('click', this.myHideAutocompleteCallback, false);
                this.isAddedEventListenerOnBodyClick = true;
            }

        } else {
            this.autocompleteArray = null;
        }

        this.changeEventLock = false;

        if (await ObjectHelper.IsNotNullAndUndefined(this.onChange) && !this.forceChange) {
            this.onChange();
        }
    }

    async captionChanged(newValue, oldValue) {
        this.changeEventLock = false;
    }

    public async HideAutocomplete() {
        this.removeAutocompleteEventListener();
    }

    removeAutocompleteEventListener() {
        if (this.isAddedEventListenerOnBodyClick) {
            document.body.removeEventListener('click', this.myHideAutocompleteCallback, false);
            this.customElement.find('[role="autocomplete"]').hide();
            this.isAddedEventListenerOnBodyClick = false;
        }
    }

    public async SelectAutocompleteValue(item: any) {
        this.changeEventLock = true;

        this.value = item.Caption;
        this.valueId = item.Id;
        await this.HideAutocomplete();
    }

}